<ngx-intl-tel-input
  cssClass="form-control"
  [preferredCountries]="preferredCountries"
  [enableAutoCountrySelect]="true"
  [enablePlaceholder]="true"
  [customPlaceholder]="placeholder"
  [selectFirstCountry]="true"
  [phoneValidation]="true"
  searchCountryPlaceholder="Suchen"
  [formControl]="innerFormControl"
></ngx-intl-tel-input>
